export enum ReleaseStatus {
    draft = 'DRAFT',
    submitted = 'SUBMITTED',
    failed = 'FAILED',
    scheduled = 'SCHEDULED',
    published = 'PUBLISHED',
    retracted = 'RETRACTED'
}
